// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Pages2_divUp__EWqun {
    0% {
        opacity: 0;
        transform: translateY(40px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media only screen and (max-width: 1299px) {
    .Pages2_wrap__6NJ84 {
        width: 100vw;
        padding: 84px 0 120px;
        min-height: calc(100vh - 231px);
    }

    .Pages2_container__l55lk {
        width: 100vw;
        margin: 0 auto;
    }

    .Pages2_categoryContainer__liEot {
        text-align: center;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 13px;
    }

    .Pages2_categoryContainer__liEot span:nth-child(1) {
        color: #222222;
        font-size: 32px;
        font-weight: bold;
    }

    .Pages2_categoryContainer__liEot span:nth-child(2) {
        display: inline-block;
        padding: 3px 11px;
        background-color: #DC140A;
        border-radius: 16px;
        color: #FFFFFF;
        font-size: 12px;
        font-weight: bold;
        margin-top: auto;
        margin-bottom: 7px;
    }

    .Pages2_artistContainer__2gKG2 {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        padding: 0 calc((100vw - ((max(160px, min(44.4vw, 310px)) * 2) + 8px)) / 2);
        justify-content: flex-start;
        transition: 0.3s ease-out;
    }

    .Pages2_musicianContainer__gTMpC {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        padding: 0 calc((100vw - ((max(160px, min(44.4vw, 310px)) * 2) + 8px)) / 2);
        justify-content: flex-start;
        transition: 0.3s ease-out;
    }

    .Pages2_artistItem__LHaP1 {
        display: flex;
        flex-flow: column;
        gap: 8px;
        cursor: pointer;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_artistItemImg__he2Uv,
    .Pages2_artistItemImg__he2Uv > img
    {
        width: max(160px, min(44.4vw, 310px));
        height: max(160px, min(44.4vw, 310px));
        transition: 0.3s ease-out;
        display: block;
        object-fit: cover;
        object-position: center 10%;
    }

    .Pages2_artistItemImg__he2Uv {
        overflow: hidden;
        position: relative;
    }

    .Pages2_artistItem__LHaP1:hover .Pages2_artistItemImg__he2Uv > img {
        transform: scale(1.1);
    }

    .Pages2_artistItemNameContainer__F8jwK {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 38px;
        background-color: #222222;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Pages2_artistItemName__LTbzn {
        position: relative;
        color: #f4f4f4;
        font-size: 14px;
        font-weight: 600;
    }

    .Pages2_artistItemName__LTbzn > span {
        display: inline-block;
        position: relative;
    }

    .Pages2_artistItem__LHaP1:hover > .Pages2_artistItemName__LTbzn {
        color: #DC140A;
    }

    .Pages2_musicianItem__IpBGv {
        display: flex;
        flex-flow: column;
        gap: 10px;
        cursor: pointer;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_musicianItemImg__PJBjy,
    .Pages2_musicianItemImg__PJBjy > img
    {
        width: max(160px, min(44.4vw, 310px));
        height: max(160px, min(44.4vw, 310px));
        transition: 0.3s ease-out;
        display: block;
        object-fit: cover;
        object-position: center 10%;
    }

    .Pages2_musicianItemImg__PJBjy {
        overflow: hidden;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_musicianItemImg__PJBjy > img {
        transform: scale(1.1);
    }

    .Pages2_musicianItemName__huPm4 {
        color: #222222;
        font-size: 12px;
        font-weight: 600;
        text-align: center;
    }

    .Pages2_musicianItemName__huPm4 > span {
        display: inline-block;
        position: relative;
    }

    .Pages2_musicianItem__IpBGv:hover > .Pages2_musicianItemName__huPm4 {
        color: #DC140A;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm {
        opacity: 1;
        visibility: visible;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm > hr:nth-child(1) {
        transform: rotate(270deg);
    }
    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm > hr:nth-child(2) {
        transform: rotate(360deg);
    }

    .Pages2_plusShape__DivXm {
        position: absolute;
        top: 50%;
        right: -17px;
        width: 9px;
        height: 9px;
        transform: translateY(-50%);
        transition: 0.3s ease-out;
    }

    .Pages2_plusShape__DivXm > div {
        width: 9px;
        height: 1px;
        background-color: #f4f4f4;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: 0.3s ease-out;
    }

    .Pages2_plusShape__DivXm > div:nth-child(2) {
        transform: translateY(-50%) rotate(90deg);
    }

    .Pages2_artistNodataContainer__QIWdB {
        margin-bottom: 160px;
        animation: Pages2_divUp__EWqun 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
        width: 100%;
    }

    .Pages2_musicianNodataContainer__DCs9K {
        margin-bottom: 160px;
        animation: Pages2_divUp__EWqun 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
        width: 100%;
    }

    .Pages2_productionNoData__yd0MN {
        color: #222222;
        font-size: 16px;
        font-weight: 600;
        display: block;
        text-align: center;
        margin-top: 110px;
    }

    .Pages2_contentContainer__2NJib {
        margin: 0 auto;
        height: auto;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        padding: 12px;
    }

    .Pages2_news__9b6MV {
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, 166px);
        grid-auto-rows: 1px;
    }

    .Pages2_newsitem__W-iBe {
        margin: 0 8px;
        cursor: pointer;
        position: relative;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_newsitem__W-iBe:hover > .Pages2_imgContainer__hlPSO > img {
        transform: scale(1.1);
    }

    .Pages2_newsitem__W-iBe > .Pages2_imgContainer__hlPSO > img {
        width: 152px;
        transition: 0.3s ease-in-out;
        overflow: hidden;
        display: block;
    }

    .Pages2_small__ouAX1 {
        grid-row-end: span 153;
    }

    .Pages2_big__3Gssp {
        grid-row-end: span 299;
    }

    .Pages2_small__ouAX1 > .Pages2_imgContainer__hlPSO > img {
        height: 102px;
    }

    .Pages2_big__3Gssp .Pages2_imgContainer__hlPSO > img {
        height: 228px;
    }

    .Pages2_imgContainer__hlPSO {
        width: 152px;
        overflow: hidden;
    }

    .Pages2_tagContainer__g1VpW {
        color: #DC140A;
        font-size: 10px;
        font-weight: 500;
        margin: 4px 0;
        display: -webkit-box;
        width: 152px;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .Pages2_tagContainer__g1VpW > span {
        margin-right: 8px;
    }

    .Pages2_themeContainer__J-N-Y {
        overflow: hidden;
        color: #1C1C1C;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
    }

    .Pages2_themeContainer__J-N-Y > span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .Pages2_pagenationContainer__ly5Os {
        width: 100vw;
        margin: 0 auto;
    }

    .Pages2_moreContainer__vNqU6 {
        width: 100vw;
        margin: 0 auto;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        padding: 0 20px;
    }

    .Pages2_moreThemeContainer__kWWRH {
        border-top: 2px solid #DC140A;
        border-bottom: 1px solid #DDDDDD;
        padding: 14px 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .Pages2_moreTheme__EpTBb {
        color: #222222;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
    }

    .Pages2_moreDate__QNO9M {
        color: #A2A2A2;
        font-size: 12px;
        font-weight: 300;
        flex-shrink: 0;
    }

    .Pages2_moreContentContainer__fIc-T {
        padding: 30px 0;
        display: flex;
        flex-flow: column;
        gap: 40px;
    }

    .Pages2_moreContent__cUANZ {
        color: #434343;
        font-size: 12px;
        line-height: 20px;
        white-space: pre-line;
    }
    .Pages2_moreContentContainer__fIc-T div:nth-child(2) {
        max-width: 1200px;
        overflow: hidden;
    }
    .Pages2_moreContentContainer__fIc-T div:nth-child(2) > img {
        max-width: 100%;
    }

    .Pages2_moreImg__9pTVM {
        width: 152px;
    }

    .Pages2_bigSize__8QAJp {
        height: 228px;
    }

    .Pages2_smallSize__YzVCs {
        height: 102px;
    }

    .Pages2_backToList__pVKC\\+ {
        color: #FFFFFF;
        background-color: #DC140A;
        border-radius: 16px;
        font-size: 16px;
        font-weight: bold;
        padding: 0 16px;
        display: flex;
        width: 71px;
        height: 29px;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        gap: 8px;
    }

    .Pages2_backToList__pVKC\\+ > img {
        width: 6px;
    }

    .Pages2_notice__vJXYp {
        width: calc(100vw - 40px);
        margin: 0 auto;
        border-top: 2px solid #DC140A;
        padding: 0 10px;
    }

    .Pages2_noticeItem__LuA56 {
        display: flex;
        flex-flow: column;
        gap: 4px;
        border-bottom: 1px solid #DDDDDD;
        padding: 14px 0;
    }

    .Pages2_noticeItemTop__o1WBx {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 4px;
    }

    .Pages2_noticeItemTheme__Cqf9B {
        color: #1C1C1D;
        font-size: 12px;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .Pages2_noticeItemDate__kCYQg {
        flex-shrink: 0;
        color: #A2A2A2;
        font-size: 12px;
        font-weight: 300;
    }

    .Pages2_noticeItemDate__kCYQg > span {
        font-size: 12px;
    }

    .Pages2_noticeItemBottom__jU86p {
        width: 785px;
    }

    .Pages2_noticeItemContent__I1XXe {
        color: #434343;
        font-size: 12px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .Pages2_buttonContainer__JfN69 {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        flex-direction: column;
        gap: 20px;
    }

    .Pages2_noticeDownload__NCIfa {
        display: flex;
        gap: 16px;
        overflow-x: scroll !important;
    }

    .Pages2_noticeDownloadBtn__yInGb {
        background-color: #F4F4F4;
        height: 25px;
        display: flex;
        border-radius: 24px;
        gap: 8px;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        color: #222222;
        font-size: 12px;
        cursor: pointer;
        max-width: 260px;
    }

    .Pages2_noticeDownloadBtn__yInGb > img {
        width: 10px;
    }

    .Pages2_spanSplit__KDZra {
        display: flex;
        min-width: 0;
    }

    .Pages2_spanSplit__KDZra > span:first-child {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .Pages2_spanSplit__KDZra > span:last-child {
        flex-shrink: 0;
    }
}

@media only screen and (min-width: 1300px) {
    .Pages2_wrap__6NJ84 {
        width: 100%;
        padding: 148px 0 240px;
    }

    .Pages2_container__l55lk {
        width: 1300px;
        margin: 0 auto;
    }

    .Pages2_categoryContainer__liEot {
        text-align: center;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

    .Pages2_categoryContainer__liEot span:nth-child(1) {
        color: #222222;
        font-size: 64px;
        font-weight: bold;
    }

    .Pages2_categoryContainer__liEot span:nth-child(2) {
        display: inline-block;
        padding: 4px 16px;
        background-color: #DC140A;
        border-radius: 16px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: bold;
        margin-top: auto;
        margin-bottom: 19px;
    }

    .Pages2_artistContainer__2gKG2 {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
    }

    .Pages2_musicianContainer__gTMpC {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
    }

    .Pages2_artistItem__LHaP1 {
        display: flex;
        flex-flow: column;
        gap: 8px;
        cursor: pointer;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_artistItemImg__he2Uv,
    .Pages2_artistItemImg__he2Uv > img
    {
        width: 310px;
        height: 310px;
        transition: 0.3s ease-out;
        display: block;
        object-fit: cover;
        object-position: center 10%;
    }

    .Pages2_artistItemImg__he2Uv {
        overflow: hidden;
    }

    .Pages2_artistItem__LHaP1:hover .Pages2_artistItemImg__he2Uv > img {
        transform: scale(1.1);
    }

    .Pages2_artistItemNameContainer__F8jwK {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 62px;
        background-color: #222222;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Pages2_artistItemName__LTbzn {
        position: relative;
        color: #f4f4f4;
        font-size: 26px;
        font-weight: 600;
    }

    .Pages2_artistItemName__LTbzn > span {
        display: inline-block;
        position: relative;
    }

    .Pages2_artistItem__LHaP1:hover > .Pages2_artistItemName__LTbzn {
        color: #DC140A;
    }

    .Pages2_artistItem__LHaP1:hover .Pages2_plusShape__DivXm {
        opacity: 1;
        visibility: visible;
        transform: translateY(-50%) rotate(270deg);
    }

    .Pages2_musicianItem__IpBGv {
        display: flex;
        flex-flow: column;
        gap: 8px;
        cursor: pointer;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_musicianItemImg__PJBjy,
    .Pages2_musicianItemImg__PJBjy > img
    {
        width: 310px;
        height: 310px;
        transition: 0.3s ease-out;
        display: block;
        object-fit: cover;
        object-position: center 10%;
    }

    .Pages2_musicianItemImg__PJBjy {
        overflow: hidden;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_musicianItemImg__PJBjy > img {
        transform: scale(1.1);
    }

    .Pages2_musicianItemName__huPm4 {
        color: #222222;
        font-size: 26px;
        font-weight: 500;
        text-align: center;
    }

    .Pages2_musicianItemName__huPm4 > span {
        display: inline-block;
        position: relative;
    }

    .Pages2_musicianItem__IpBGv:hover > .Pages2_musicianItemName__huPm4 {
        color: #DC140A;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm {
        opacity: 1;
        visibility: visible;
    }

    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm > hr:nth-child(1) {
        transform: rotate(270deg);
    }
    .Pages2_musicianItem__IpBGv:hover .Pages2_plusShape__DivXm > hr:nth-child(2) {
        transform: rotate(360deg);
    }

    .Pages2_plusShape__DivXm {
        position: absolute;
        top: 50%;
        right: -24px;
        width: 16px;
        height: 16px;
        transform: translateY(-50%);
        transition: 0.3s ease-out;
        visibility: hidden;
        opacity: 0;
    }

    .Pages2_plusShape__DivXm > div {
        width: 16px;
        height: 2px;
        background-color: #C93121;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: 0.3s ease-out;
    }

    .Pages2_plusShape__DivXm > div:nth-child(2) {
        transform: translateY(-50%) rotate(90deg);
    }

    .Pages2_artistNodataContainer__QIWdB {
        margin-bottom: 160px;
        animation: Pages2_divUp__EWqun 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
        width: 100%;
    }

    .Pages2_musicianNodataContainer__DCs9K {
        margin-bottom: 160px;
        animation: Pages2_divUp__EWqun 0.6s ease-out;
        animation-fill-mode: both;
        animation-delay: 0.6s;
        width: 100%;
    }

    .Pages2_productionNoData__yd0MN {
        color: #222222;
        font-size: 40px;
        font-weight: 600;
        display: block;
        text-align: center;
        margin-top: 120px;
    }

    .Pages2_contentContainer__2NJib {
        margin: 0 auto;
        height: auto;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
    }

    .Pages2_news__9b6MV {
        width: 1350px;
        display: grid;
        grid-template-columns: repeat(auto-fill, 450px);
        grid-auto-rows: 1px;
    }

    .Pages2_newsitem__W-iBe {
        margin: 0 25px;
        cursor: pointer;
        position: relative;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-fill-mode: both;
    }

    .Pages2_newsitem__W-iBe:hover > .Pages2_imgContainer__hlPSO > img {
        transform: scale(1.1);
    }

    .Pages2_newsitem__W-iBe > .Pages2_imgContainer__hlPSO > img {
        width: 400px;
        transition: 0.3s ease-in-out;
        overflow: hidden;
        display: block;
    }

    .Pages2_small__ouAX1 {
        grid-row-end: span 411;
    }

    .Pages2_big__3Gssp {
        grid-row-end: span 745;
    }

    .Pages2_small__ouAX1 > .Pages2_imgContainer__hlPSO > img {
        height: 266px;

    }

    .Pages2_big__3Gssp .Pages2_imgContainer__hlPSO > img {
        height: 600px;
    }

    .Pages2_imgContainer__hlPSO {
        width: 400px;
        overflow: hidden;
    }

    .Pages2_tagContainer__g1VpW {
        color: #DC140A;
        font-size: 18px;
        font-weight: 500;
        margin: 16px 0 8px;
        display: -webkit-box;
        width: 400px;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .Pages2_tagContainer__g1VpW > span {
        margin-right: 16px;
    }

    .Pages2_themeContainer__J-N-Y {
        overflow: hidden;
        color: #1C1C1C;
        font-size: 22px;
        font-weight: 600;
        line-height: 30px;
    }

    .Pages2_themeContainer__J-N-Y > span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .Pages2_pagenationContainer__ly5Os {
        width: 1300px;
        margin: 0 auto;
    }

    .Pages2_moreContainer__vNqU6 {
        width: 1300px;
        margin: 0 auto;
        animation: Pages2_divUp__EWqun 0.6s ease-in-out;
        animation-delay: 0.6s;
        animation-fill-mode: both;
    }

    .Pages2_moreThemeContainer__kWWRH {
        border-top: 2px solid #DC140A;
        border-bottom: 1px solid #DDDDDD;
        padding: 48px 33px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
    }

    .Pages2_moreTheme__EpTBb {
        color: #222222;
        font-size: 40px;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .Pages2_moreDate__QNO9M {
        color: #A2A2A2;
        font-size: 26px;
        flex-shrink: 0;
    }

    .Pages2_moreContentContainer__fIc-T {
        padding: 80px 33px;
        display: flex;
        flex-flow: column;
        gap: 80px;
    }

    .Pages2_moreContent__cUANZ {
        color: #434343;
        font-size: 26px;
        line-height: 44px;
        white-space: pre-line;
    }
    .Pages2_moreContentContainer__fIc-T div:nth-child(2) {
        max-width: 1200px;
        overflow: hidden;
    }
    .Pages2_moreContentContainer__fIc-T div:nth-child(2) > img {
        max-width: 100%;
    }

    .Pages2_moreImg__9pTVM {
        width: 400px;
    }

    .Pages2_bigSize__8QAJp {
        height: 600px;
    }

    .Pages2_smallSize__YzVCs {
        height: 266px;
    }

    .Pages2_backToList__pVKC\\+ {
        color: #FFFFFF;
        background-color: #DC140A;
        border-radius: 24px;
        font-size: 26px;
        font-weight: bold;
        padding: 0 32px;
        display: flex;
        width: 129px;
        height: 48px;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }

    .Pages2_notice__vJXYp {
        width: 1300px;
        margin: 0 auto;
        border-top: 2px solid #DC140A;
    }

    .Pages2_noticeItem__LuA56 {
        padding: 40px 32px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #DDDDDD;
    }

    .Pages2_noticeItemTop__o1WBx {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 16px;
        width: 785px;
    }

    .Pages2_noticeItemTheme__Cqf9B {
        color: #1C1C1D;
        font-size: 26px;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .Pages2_noticeItemDate__kCYQg {
        flex-shrink: 0;
        color: #A2A2A2;
        font-size: 26px;
        font-weight: 300;
    }

    .Pages2_noticeItemContent__I1XXe {
        color: #434343;
        font-size: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .Pages2_buttonContainer__JfN69 {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .Pages2_noticeDownload__NCIfa {
        display: flex;
        gap: 16px;
    }

    .Pages2_noticeDownloadBtn__yInGb {
        background-color: #F4F4F4;
        height: 49px;
        display: flex;
        border-radius: 24px;
        gap: 16px;
        justify-content: space-between;
        align-items: center;
        padding: 0 32px;
        color: #222222;
        font-size: 26px;
        cursor: pointer;
        max-width: 260px;
    }

    .Pages2_spanSplit__KDZra {
        display: flex;
        min-width: 0;
    }

    .Pages2_spanSplit__KDZra > span:first-child {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .Pages2_spanSplit__KDZra > span:last-child {
        flex-shrink: 0;
    }
}

@media only screen and (min-width: 672px) and (max-width: 1002px) {
    .Pages2_artistContainer__2gKG2 {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
        padding: 0 calc((100vw - 640px) / 2);
    }
    .Pages2_musicianContainer__gTMpC {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
        padding: 0 calc((100vw - 640px) / 2);
    }
}

@media only screen and (min-width: 1003px) and (max-width: 1299px) {
    .Pages2_artistContainer__2gKG2 {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
        padding: 0 calc((100vw - 970px) / 2);
    }
    .Pages2_musicianContainer__gTMpC {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: 0.3s ease-out;
        padding: 0 calc((100vw - 970px) / 2);
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Pages2.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;QACrB,+BAA+B;IACnC;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,+CAAiC;QACjC,yBAAyB;QACzB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,eAAe;QACf,2EAA2E;QAC3E,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,eAAe;QACf,2EAA2E;QAC3E,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,QAAQ;QACR,eAAe;QACf,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;;;QAGI,qCAAqC;QACrC,sCAAsC;QACtC,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,yBAAyB;QACzB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,eAAe;QACf,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;;;QAGI,qCAAqC;QACrC,sCAAsC;QACtC,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,YAAY;QACZ,UAAU;QACV,WAAW;QACX,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,oBAAoB;QACpB,4CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,4CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,+CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,+CAA+C;QAC/C,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,4BAA4B;QAC5B,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,oBAAoB;QACpB,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,qBAAqB;QACrB,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;IAChC;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,+CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;QAChC,eAAe;QACf,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,qBAAqB;IACzB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,aAAa;QACb,WAAW;QACX,YAAY;QACZ,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,QAAQ;QACR,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,gBAAgB;QAChB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,SAAS;QACT,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,cAAc;QACd,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,+CAAiC;QACjC,yBAAyB;QACzB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,QAAQ;QACR,eAAe;QACf,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;;;QAGI,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,yBAAyB;QACzB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,QAAQ;QACR,eAAe;QACf,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;;;QAGI,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,2BAA2B;QAC3B,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;QACzB,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,oBAAoB;QACpB,4CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,4CAA8B;QAC9B,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,+CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,aAAa;QACb,+CAA+C;QAC/C,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,+CAAiC;QACjC,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,4BAA4B;QAC5B,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,qBAAqB;QACrB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,+CAAiC;QACjC,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;QAChC,kBAAkB;QAClB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,qBAAqB;IACzB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,cAAc;QACd,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;QACzB,oCAAoC;IACxC;IACA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;QACzB,oCAAoC;IACxC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;QACzB,oCAAoC;IACxC;IACA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,2BAA2B;QAC3B,yBAAyB;QACzB,oCAAoC;IACxC;AACJ","sourcesContent":["@keyframes divUp {\n    0% {\n        opacity: 0;\n        transform: translateY(40px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media only screen and (max-width: 1299px) {\n    .wrap {\n        width: 100vw;\n        padding: 84px 0 120px;\n        min-height: calc(100vh - 231px);\n    }\n\n    .container {\n        width: 100vw;\n        margin: 0 auto;\n    }\n\n    .categoryContainer {\n        text-align: center;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 13px;\n    }\n\n    .categoryContainer span:nth-child(1) {\n        color: #222222;\n        font-size: 32px;\n        font-weight: bold;\n    }\n\n    .categoryContainer span:nth-child(2) {\n        display: inline-block;\n        padding: 3px 11px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        color: #FFFFFF;\n        font-size: 12px;\n        font-weight: bold;\n        margin-top: auto;\n        margin-bottom: 7px;\n    }\n\n    .artistContainer {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n        padding: 0 calc((100vw - ((max(160px, min(44.4vw, 310px)) * 2) + 8px)) / 2);\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n    }\n\n    .musicianContainer {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n        padding: 0 calc((100vw - ((max(160px, min(44.4vw, 310px)) * 2) + 8px)) / 2);\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n    }\n\n    .artistItem {\n        display: flex;\n        flex-flow: column;\n        gap: 8px;\n        cursor: pointer;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .artistItemImg,\n    .artistItemImg > img\n    {\n        width: max(160px, min(44.4vw, 310px));\n        height: max(160px, min(44.4vw, 310px));\n        transition: 0.3s ease-out;\n        display: block;\n        object-fit: cover;\n        object-position: center 10%;\n    }\n\n    .artistItemImg {\n        overflow: hidden;\n        position: relative;\n    }\n\n    .artistItem:hover .artistItemImg > img {\n        transform: scale(1.1);\n    }\n\n    .artistItemNameContainer {\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 38px;\n        background-color: #222222;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .artistItemName {\n        position: relative;\n        color: #f4f4f4;\n        font-size: 14px;\n        font-weight: 600;\n    }\n\n    .artistItemName > span {\n        display: inline-block;\n        position: relative;\n    }\n\n    .artistItem:hover > .artistItemName {\n        color: #DC140A;\n    }\n\n    .musicianItem {\n        display: flex;\n        flex-flow: column;\n        gap: 10px;\n        cursor: pointer;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .musicianItemImg,\n    .musicianItemImg > img\n    {\n        width: max(160px, min(44.4vw, 310px));\n        height: max(160px, min(44.4vw, 310px));\n        transition: 0.3s ease-out;\n        display: block;\n        object-fit: cover;\n        object-position: center 10%;\n    }\n\n    .musicianItemImg {\n        overflow: hidden;\n    }\n\n    .musicianItem:hover .musicianItemImg > img {\n        transform: scale(1.1);\n    }\n\n    .musicianItemName {\n        color: #222222;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n    }\n\n    .musicianItemName > span {\n        display: inline-block;\n        position: relative;\n    }\n\n    .musicianItem:hover > .musicianItemName {\n        color: #DC140A;\n    }\n\n    .musicianItem:hover .plusShape {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .musicianItem:hover .plusShape > hr:nth-child(1) {\n        transform: rotate(270deg);\n    }\n    .musicianItem:hover .plusShape > hr:nth-child(2) {\n        transform: rotate(360deg);\n    }\n\n    .plusShape {\n        position: absolute;\n        top: 50%;\n        right: -17px;\n        width: 9px;\n        height: 9px;\n        transform: translateY(-50%);\n        transition: 0.3s ease-out;\n    }\n\n    .plusShape > div {\n        width: 9px;\n        height: 1px;\n        background-color: #f4f4f4;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        transition: 0.3s ease-out;\n    }\n\n    .plusShape > div:nth-child(2) {\n        transform: translateY(-50%) rotate(90deg);\n    }\n\n    .artistNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n        width: 100%;\n    }\n\n    .musicianNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n        width: 100%;\n    }\n\n    .productionNoData {\n        color: #222222;\n        font-size: 16px;\n        font-weight: 600;\n        display: block;\n        text-align: center;\n        margin-top: 110px;\n    }\n\n    .contentContainer {\n        margin: 0 auto;\n        height: auto;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        padding: 12px;\n    }\n\n    .news {\n        margin: 0 auto;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, 166px);\n        grid-auto-rows: 1px;\n    }\n\n    .newsitem {\n        margin: 0 8px;\n        cursor: pointer;\n        position: relative;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .newsitem:hover > .imgContainer > img {\n        transform: scale(1.1);\n    }\n\n    .newsitem > .imgContainer > img {\n        width: 152px;\n        transition: 0.3s ease-in-out;\n        overflow: hidden;\n        display: block;\n    }\n\n    .small {\n        grid-row-end: span 153;\n    }\n\n    .big {\n        grid-row-end: span 299;\n    }\n\n    .small > .imgContainer > img {\n        height: 102px;\n    }\n\n    .big .imgContainer > img {\n        height: 228px;\n    }\n\n    .imgContainer {\n        width: 152px;\n        overflow: hidden;\n    }\n\n    .tagContainer {\n        color: #DC140A;\n        font-size: 10px;\n        font-weight: 500;\n        margin: 4px 0;\n        display: -webkit-box;\n        width: 152px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n    }\n\n    .tagContainer > span {\n        margin-right: 8px;\n    }\n\n    .themeContainer {\n        overflow: hidden;\n        color: #1C1C1C;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n    }\n\n    .themeContainer > span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n    }\n\n    .pagenationContainer {\n        width: 100vw;\n        margin: 0 auto;\n    }\n\n    .moreContainer {\n        width: 100vw;\n        margin: 0 auto;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        padding: 0 20px;\n    }\n\n    .moreThemeContainer {\n        border-top: 2px solid #DC140A;\n        border-bottom: 1px solid #DDDDDD;\n        padding: 14px 0;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .moreTheme {\n        color: #222222;\n        font-size: 20px;\n        line-height: 28px;\n        font-weight: bold;\n    }\n\n    .moreDate {\n        color: #A2A2A2;\n        font-size: 12px;\n        font-weight: 300;\n        flex-shrink: 0;\n    }\n\n    .moreContentContainer {\n        padding: 30px 0;\n        display: flex;\n        flex-flow: column;\n        gap: 40px;\n    }\n\n    .moreContent {\n        color: #434343;\n        font-size: 12px;\n        line-height: 20px;\n        white-space: pre-line;\n    }\n    .moreContentContainer div:nth-child(2) {\n        max-width: 1200px;\n        overflow: hidden;\n    }\n    .moreContentContainer div:nth-child(2) > img {\n        max-width: 100%;\n    }\n\n    .moreImg {\n        width: 152px;\n    }\n\n    .bigSize {\n        height: 228px;\n    }\n\n    .smallSize {\n        height: 102px;\n    }\n\n    .backToList {\n        color: #FFFFFF;\n        background-color: #DC140A;\n        border-radius: 16px;\n        font-size: 16px;\n        font-weight: bold;\n        padding: 0 16px;\n        display: flex;\n        width: 71px;\n        height: 29px;\n        justify-content: space-between;\n        align-items: center;\n        cursor: pointer;\n        gap: 8px;\n    }\n\n    .backToList > img {\n        width: 6px;\n    }\n\n    .notice {\n        width: calc(100vw - 40px);\n        margin: 0 auto;\n        border-top: 2px solid #DC140A;\n        padding: 0 10px;\n    }\n\n    .noticeItem {\n        display: flex;\n        flex-flow: column;\n        gap: 4px;\n        border-bottom: 1px solid #DDDDDD;\n        padding: 14px 0;\n    }\n\n    .noticeItemTop {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        gap: 4px;\n    }\n\n    .noticeItemTheme {\n        color: #1C1C1D;\n        font-size: 12px;\n        font-weight: 600;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .noticeItemDate {\n        flex-shrink: 0;\n        color: #A2A2A2;\n        font-size: 12px;\n        font-weight: 300;\n    }\n\n    .noticeItemDate > span {\n        font-size: 12px;\n    }\n\n    .noticeItemBottom {\n        width: 785px;\n    }\n\n    .noticeItemContent {\n        color: #434343;\n        font-size: 12px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .buttonContainer {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 20px;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .noticeDownload {\n        display: flex;\n        gap: 16px;\n        overflow-x: scroll !important;\n    }\n\n    .noticeDownloadBtn {\n        background-color: #F4F4F4;\n        height: 25px;\n        display: flex;\n        border-radius: 24px;\n        gap: 8px;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 16px;\n        color: #222222;\n        font-size: 12px;\n        cursor: pointer;\n        max-width: 260px;\n    }\n\n    .noticeDownloadBtn > img {\n        width: 10px;\n    }\n\n    .spanSplit {\n        display: flex;\n        min-width: 0;\n    }\n\n    .spanSplit > span:first-child {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .spanSplit > span:last-child {\n        flex-shrink: 0;\n    }\n}\n\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n        padding: 148px 0 240px;\n    }\n\n    .container {\n        width: 1300px;\n        margin: 0 auto;\n    }\n\n    .categoryContainer {\n        text-align: center;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .categoryContainer span:nth-child(1) {\n        color: #222222;\n        font-size: 64px;\n        font-weight: bold;\n    }\n\n    .categoryContainer span:nth-child(2) {\n        display: inline-block;\n        padding: 4px 16px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        color: #FFFFFF;\n        font-size: 20px;\n        font-weight: bold;\n        margin-top: auto;\n        margin-bottom: 19px;\n    }\n\n    .artistContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n    }\n\n    .musicianContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n    }\n\n    .artistItem {\n        display: flex;\n        flex-flow: column;\n        gap: 8px;\n        cursor: pointer;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .artistItemImg,\n    .artistItemImg > img\n    {\n        width: 310px;\n        height: 310px;\n        transition: 0.3s ease-out;\n        display: block;\n        object-fit: cover;\n        object-position: center 10%;\n    }\n\n    .artistItemImg {\n        overflow: hidden;\n    }\n\n    .artistItem:hover .artistItemImg > img {\n        transform: scale(1.1);\n    }\n\n    .artistItemNameContainer {\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 62px;\n        background-color: #222222;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .artistItemName {\n        position: relative;\n        color: #f4f4f4;\n        font-size: 26px;\n        font-weight: 600;\n    }\n\n    .artistItemName > span {\n        display: inline-block;\n        position: relative;\n    }\n\n    .artistItem:hover > .artistItemName {\n        color: #DC140A;\n    }\n\n    .artistItem:hover .plusShape {\n        opacity: 1;\n        visibility: visible;\n        transform: translateY(-50%) rotate(270deg);\n    }\n\n    .musicianItem {\n        display: flex;\n        flex-flow: column;\n        gap: 8px;\n        cursor: pointer;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .musicianItemImg,\n    .musicianItemImg > img\n    {\n        width: 310px;\n        height: 310px;\n        transition: 0.3s ease-out;\n        display: block;\n        object-fit: cover;\n        object-position: center 10%;\n    }\n\n    .musicianItemImg {\n        overflow: hidden;\n    }\n\n    .musicianItem:hover .musicianItemImg > img {\n        transform: scale(1.1);\n    }\n\n    .musicianItemName {\n        color: #222222;\n        font-size: 26px;\n        font-weight: 500;\n        text-align: center;\n    }\n\n    .musicianItemName > span {\n        display: inline-block;\n        position: relative;\n    }\n\n    .musicianItem:hover > .musicianItemName {\n        color: #DC140A;\n    }\n\n    .musicianItem:hover .plusShape {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .musicianItem:hover .plusShape > hr:nth-child(1) {\n        transform: rotate(270deg);\n    }\n    .musicianItem:hover .plusShape > hr:nth-child(2) {\n        transform: rotate(360deg);\n    }\n\n    .plusShape {\n        position: absolute;\n        top: 50%;\n        right: -24px;\n        width: 16px;\n        height: 16px;\n        transform: translateY(-50%);\n        transition: 0.3s ease-out;\n        visibility: hidden;\n        opacity: 0;\n    }\n\n    .plusShape > div {\n        width: 16px;\n        height: 2px;\n        background-color: #C93121;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        transition: 0.3s ease-out;\n    }\n\n    .plusShape > div:nth-child(2) {\n        transform: translateY(-50%) rotate(90deg);\n    }\n\n    .artistNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n        width: 100%;\n    }\n\n    .musicianNodataContainer {\n        margin-bottom: 160px;\n        animation: divUp 0.6s ease-out;\n        animation-fill-mode: both;\n        animation-delay: 0.6s;\n        width: 100%;\n    }\n\n    .productionNoData {\n        color: #222222;\n        font-size: 40px;\n        font-weight: 600;\n        display: block;\n        text-align: center;\n        margin-top: 120px;\n    }\n\n    .contentContainer {\n        margin: 0 auto;\n        height: auto;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n    }\n\n    .news {\n        width: 1350px;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, 450px);\n        grid-auto-rows: 1px;\n    }\n\n    .newsitem {\n        margin: 0 25px;\n        cursor: pointer;\n        position: relative;\n        animation: divUp 0.6s ease-in-out;\n        animation-fill-mode: both;\n    }\n\n    .newsitem:hover > .imgContainer > img {\n        transform: scale(1.1);\n    }\n\n    .newsitem > .imgContainer > img {\n        width: 400px;\n        transition: 0.3s ease-in-out;\n        overflow: hidden;\n        display: block;\n    }\n\n    .small {\n        grid-row-end: span 411;\n    }\n\n    .big {\n        grid-row-end: span 745;\n    }\n\n    .small > .imgContainer > img {\n        height: 266px;\n\n    }\n\n    .big .imgContainer > img {\n        height: 600px;\n    }\n\n    .imgContainer {\n        width: 400px;\n        overflow: hidden;\n    }\n\n    .tagContainer {\n        color: #DC140A;\n        font-size: 18px;\n        font-weight: 500;\n        margin: 16px 0 8px;\n        display: -webkit-box;\n        width: 400px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n    }\n\n    .tagContainer > span {\n        margin-right: 16px;\n    }\n\n    .themeContainer {\n        overflow: hidden;\n        color: #1C1C1C;\n        font-size: 22px;\n        font-weight: 600;\n        line-height: 30px;\n    }\n\n    .themeContainer > span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n    }\n\n    .pagenationContainer {\n        width: 1300px;\n        margin: 0 auto;\n    }\n\n    .moreContainer {\n        width: 1300px;\n        margin: 0 auto;\n        animation: divUp 0.6s ease-in-out;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n    }\n\n    .moreThemeContainer {\n        border-top: 2px solid #DC140A;\n        border-bottom: 1px solid #DDDDDD;\n        padding: 48px 33px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 20px;\n    }\n\n    .moreTheme {\n        color: #222222;\n        font-size: 40px;\n        font-weight: 600;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .moreDate {\n        color: #A2A2A2;\n        font-size: 26px;\n        flex-shrink: 0;\n    }\n\n    .moreContentContainer {\n        padding: 80px 33px;\n        display: flex;\n        flex-flow: column;\n        gap: 80px;\n    }\n\n    .moreContent {\n        color: #434343;\n        font-size: 26px;\n        line-height: 44px;\n        white-space: pre-line;\n    }\n    .moreContentContainer div:nth-child(2) {\n        max-width: 1200px;\n        overflow: hidden;\n    }\n    .moreContentContainer div:nth-child(2) > img {\n        max-width: 100%;\n    }\n\n    .moreImg {\n        width: 400px;\n    }\n\n    .bigSize {\n        height: 600px;\n    }\n\n    .smallSize {\n        height: 266px;\n    }\n\n    .backToList {\n        color: #FFFFFF;\n        background-color: #DC140A;\n        border-radius: 24px;\n        font-size: 26px;\n        font-weight: bold;\n        padding: 0 32px;\n        display: flex;\n        width: 129px;\n        height: 48px;\n        justify-content: space-between;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    .notice {\n        width: 1300px;\n        margin: 0 auto;\n        border-top: 2px solid #DC140A;\n    }\n\n    .noticeItem {\n        padding: 40px 32px;\n        display: flex;\n        justify-content: space-between;\n        border-bottom: 1px solid #DDDDDD;\n    }\n\n    .noticeItemTop {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        gap: 16px;\n        width: 785px;\n    }\n\n    .noticeItemTheme {\n        color: #1C1C1D;\n        font-size: 26px;\n        font-weight: bold;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .noticeItemDate {\n        flex-shrink: 0;\n        color: #A2A2A2;\n        font-size: 26px;\n        font-weight: 300;\n    }\n\n    .noticeItemContent {\n        color: #434343;\n        font-size: 18px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .buttonContainer {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .noticeDownload {\n        display: flex;\n        gap: 16px;\n    }\n\n    .noticeDownloadBtn {\n        background-color: #F4F4F4;\n        height: 49px;\n        display: flex;\n        border-radius: 24px;\n        gap: 16px;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 32px;\n        color: #222222;\n        font-size: 26px;\n        cursor: pointer;\n        max-width: 260px;\n    }\n\n    .spanSplit {\n        display: flex;\n        min-width: 0;\n    }\n\n    .spanSplit > span:first-child {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .spanSplit > span:last-child {\n        flex-shrink: 0;\n    }\n}\n\n@media only screen and (min-width: 672px) and (max-width: 1002px) {\n    .artistContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n        padding: 0 calc((100vw - 640px) / 2);\n    }\n    .musicianContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n        padding: 0 calc((100vw - 640px) / 2);\n    }\n}\n\n@media only screen and (min-width: 1003px) and (max-width: 1299px) {\n    .artistContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n        padding: 0 calc((100vw - 970px) / 2);\n    }\n    .musicianContainer {\n        display: flex;\n        gap: 20px;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        transition: 0.3s ease-out;\n        padding: 0 calc((100vw - 970px) / 2);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Pages2_wrap__6NJ84`,
	"container": `Pages2_container__l55lk`,
	"categoryContainer": `Pages2_categoryContainer__liEot`,
	"divUp": `Pages2_divUp__EWqun`,
	"artistContainer": `Pages2_artistContainer__2gKG2`,
	"musicianContainer": `Pages2_musicianContainer__gTMpC`,
	"artistItem": `Pages2_artistItem__LHaP1`,
	"artistItemImg": `Pages2_artistItemImg__he2Uv`,
	"artistItemNameContainer": `Pages2_artistItemNameContainer__F8jwK`,
	"artistItemName": `Pages2_artistItemName__LTbzn`,
	"musicianItem": `Pages2_musicianItem__IpBGv`,
	"musicianItemImg": `Pages2_musicianItemImg__PJBjy`,
	"musicianItemName": `Pages2_musicianItemName__huPm4`,
	"plusShape": `Pages2_plusShape__DivXm`,
	"artistNodataContainer": `Pages2_artistNodataContainer__QIWdB`,
	"musicianNodataContainer": `Pages2_musicianNodataContainer__DCs9K`,
	"productionNoData": `Pages2_productionNoData__yd0MN`,
	"contentContainer": `Pages2_contentContainer__2NJib`,
	"news": `Pages2_news__9b6MV`,
	"newsitem": `Pages2_newsitem__W-iBe`,
	"imgContainer": `Pages2_imgContainer__hlPSO`,
	"small": `Pages2_small__ouAX1`,
	"big": `Pages2_big__3Gssp`,
	"tagContainer": `Pages2_tagContainer__g1VpW`,
	"themeContainer": `Pages2_themeContainer__J-N-Y`,
	"pagenationContainer": `Pages2_pagenationContainer__ly5Os`,
	"moreContainer": `Pages2_moreContainer__vNqU6`,
	"moreThemeContainer": `Pages2_moreThemeContainer__kWWRH`,
	"moreTheme": `Pages2_moreTheme__EpTBb`,
	"moreDate": `Pages2_moreDate__QNO9M`,
	"moreContentContainer": `Pages2_moreContentContainer__fIc-T`,
	"moreContent": `Pages2_moreContent__cUANZ`,
	"moreImg": `Pages2_moreImg__9pTVM`,
	"bigSize": `Pages2_bigSize__8QAJp`,
	"smallSize": `Pages2_smallSize__YzVCs`,
	"backToList": `Pages2_backToList__pVKC+`,
	"notice": `Pages2_notice__vJXYp`,
	"noticeItem": `Pages2_noticeItem__LuA56`,
	"noticeItemTop": `Pages2_noticeItemTop__o1WBx`,
	"noticeItemTheme": `Pages2_noticeItemTheme__Cqf9B`,
	"noticeItemDate": `Pages2_noticeItemDate__kCYQg`,
	"noticeItemBottom": `Pages2_noticeItemBottom__jU86p`,
	"noticeItemContent": `Pages2_noticeItemContent__I1XXe`,
	"buttonContainer": `Pages2_buttonContainer__JfN69`,
	"noticeDownload": `Pages2_noticeDownload__NCIfa`,
	"noticeDownloadBtn": `Pages2_noticeDownloadBtn__yInGb`,
	"spanSplit": `Pages2_spanSplit__KDZra`
};
export default ___CSS_LOADER_EXPORT___;
